import { render } from "./JFdefeated.vue?vue&type=template&id=2c205f5b&scoped=true"
import script from "./JFdefeated.vue?vue&type=script&lang=js"
export * from "./JFdefeated.vue?vue&type=script&lang=js"

import "./JFdefeated.vue?vue&type=style&index=0&id=2c205f5b&lang=scss&scoped=true"
import "./JFdefeated.vue?vue&type=style&index=1&id=2c205f5b&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c205f5b"]])

export default __exports__